/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_OfflineInputs */

const en_loading_offline = /** @type {(inputs: Loading_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are offline. Check your internet connection to continue.`)
};

const id_loading_offline = /** @type {(inputs: Loading_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koneksi internet terputus. Periksa koneksimu untuk melanjutkan.`)
};

/**
* | output |
* | --- |
* | "You are offline. Check your internet connection to continue." |
*
* @param {Loading_OfflineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_offline = /** @type {((inputs?: Loading_OfflineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_OfflineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_offline(inputs)
	return en_loading_offline(inputs)
});